
import { WebGPUEngine } from "../../webgpuEngine.js";
import * as WebGPUConstants from "../webgpuConstants.js";
import { Effect } from "../../../Materials/effect.js";
Effect.prototype.setStorageBuffer = function (name, buffer) {
    this._engine.setStorageBuffer(name, buffer);
};
WebGPUEngine.prototype.createStorageBuffer = function (data, creationFlags) {
    return this._createBuffer(data, creationFlags | 32);
};
WebGPUEngine.prototype.updateStorageBuffer = function (buffer, data, byteOffset, byteLength) {
    var dataBuffer = buffer;
    if (byteOffset === undefined) {
        byteOffset = 0;
    }
    var view;
    if (byteLength === undefined) {
        if (data instanceof Array) {
            view = new Float32Array(data);
        }
        else if (data instanceof ArrayBuffer) {
            view = new Uint8Array(data);
        }
        else {
            view = data;
        }
        byteLength = view.byteLength;
    }
    else {
        if (data instanceof Array) {
            view = new Float32Array(data);
        }
        else if (data instanceof ArrayBuffer) {
            view = new Uint8Array(data);
        }
        else {
            view = data;
        }
    }
    this._bufferManager.setSubData(dataBuffer, byteOffset, view, 0, byteLength);
};
WebGPUEngine.prototype.readFromStorageBuffer = function (storageBuffer, offset, size, buffer) {
    var _this = this;
    size = size || storageBuffer.capacity;
    var gpuBuffer = this._bufferManager.createRawBuffer(size, WebGPUConstants.BufferUsage.MapRead | WebGPUConstants.BufferUsage.CopyDst);
    this._renderTargetEncoder.copyBufferToBuffer(storageBuffer.underlyingResource, offset !== null && offset !== void 0 ? offset : 0, gpuBuffer, 0, size);
    return new Promise(function (resolve, reject) {
        // we are using onEndFrameObservable because we need to map the gpuBuffer AFTER the command buffers
        // have been submitted, else we get the error: "Buffer used in a submit while mapped"
        _this.onEndFrameObservable.addOnce(function () {
            gpuBuffer.mapAsync(WebGPUConstants.MapMode.Read, 0, size).then(function () {
                var copyArrayBuffer = gpuBuffer.getMappedRange(0, size);
                var data = buffer;
                if (data === undefined) {
                    data = new Uint8Array(size);
                    data.set(new Uint8Array(copyArrayBuffer));
                }
                else {
                    var ctor = data.constructor; // we want to create result data with the same type as buffer (Uint8Array, Float32Array, ...)
                    data = new ctor(data.buffer);
                    data.set(new ctor(copyArrayBuffer));
                }
                gpuBuffer.unmap();
                _this._bufferManager.releaseBuffer(gpuBuffer);
                resolve(data);
            }, function (reason) { return reject(reason); });
        });
    });
};
WebGPUEngine.prototype.setStorageBuffer = function (name, buffer) {
    var _a, _b;
    (_a = this._currentDrawContext) === null || _a === void 0 ? void 0 : _a.setBuffer(name, (_b = buffer === null || buffer === void 0 ? void 0 : buffer.getBuffer()) !== null && _b !== void 0 ? _b : null);
};
//# sourceMappingURL=engine.storageBuffer.js.map